"use strict";

function findOneElement(context, selector) {
  return context.querySelector(selector);
}

function initSection(selector, callback) {
  document.querySelectorAll(selector).forEach(callback);
}

function makeEventNamespace() {
  return {
    addDelegatedEventListener(context, selector, event, handler) {
      context.addEventListener(event, (e) => {
        if (e.target.matches(selector)) {
          handler(e.target, e);
        }
      });
    },
  };
}

function displayTestimonialsSection() {
  const testimonialsSection = document.querySelector(
    ".tm-pdp__swiper"
  );
  if (testimonialsSection) {
    testimonialsSection.style.opacity = 1;
  }
}

initSection(".js-pdp-testimonials-section", (section) => {
  const swiperElement = findOneElement(
    section,
    ".tm-pdp__slider"
  );
  const namespace = makeEventNamespace();

  if (swiperElement === null) return {
    unload: null
  };

  const REAL_COUNT = 3;

  const swiperTestimonials = new Swiper(".tm-pdp__slider", {
    centeredSlides: true,
    slidesPerView: 1.14,
    spaceBetween: 15,
    loop: true,

    breakpoints: {
      768: {
        slidesPerView: 1.3,
        spaceBetween: 24
      },
      1024: {
        slidesPerView: 1.4,
        spaceBetween: 24
      },
      1270: {
        slidesPerView: 1.7,
        spaceBetween: 32
      },
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    pagination: {
      el: ".tm-pdp__pagination",
      clickable: true,
      renderBullet(index, className) {
        if (index >= REAL_COUNT) return "";
        return `<span class="${className}" data-bullet="${index}"></span>`;
      },
    },

    on: {
      init(swiper) {
        updateBullets(swiper);
      },

      slideChange(swiper) {
        updateBullets(swiper);
      },

      paginationRender(swiper) {
        const pagEl = swiper.pagination.el;
        if (pagEl.dataset.bound === "1") return;
        pagEl.dataset.bound = "1";

        pagEl.addEventListener("click", (e) => {
          const b = e.target.closest("[data-bullet]");
          if (!b) return;

          const target = Number(b.dataset.bullet);
          const active = swiper.realIndex;

          swiper.slideTo(swiper.activeIndex + (target - active), 500);
        });
      },
    },
  });

  function updateBullets(swiper) {
    const pagEl = swiper.pagination.el;
    if (!pagEl) return;

    const bullets = pagEl.querySelectorAll(".swiper-pagination-bullet");
    bullets.forEach((el) => el.classList.remove("swiper-pagination-bullet-active"));

    const active = swiper.realIndex % REAL_COUNT;

    const activeBullet = pagEl.querySelector(`[data-bullet="${active}"]`);
    if (activeBullet) activeBullet.classList.add("swiper-pagination-bullet-active");
  }

  swiperTestimonials.init();

  return {
    unload: () => {
      swiperTestimonials.destroy();
    },
  };
});

document.addEventListener("DOMContentLoaded", displayTestimonialsSection);